"use client";

import {
  clearFormData,
  getSavedFormData,
} from "@/components/tan-stack-form/form-options";
import { BillingDetailsFormData } from "@/components/billing-details-form/schema";
import { getCountryCallingCode, isSupportedCountry } from "libphonenumber-js";

// Namespaced separately from the registration flow's "billing-details" key so
// guest gifting billing details never bleed into (or out of) the member
// registration flow that shares the same browser session.
export const GIFTING_BILLING_DETAILS = "gifting-billing-details";

export const clearGiftingBillingDetailsDraft = () =>
  clearFormData(GIFTING_BILLING_DETAILS);

// Guest gifting has no authenticated contact to prefill from, so seed the phone
// field's country from the visitor's detected location. Falls back to an empty
// string when the location is unknown/unsupported (handled by PhoneNumberField).
export const getGiftingBillingDefaultValues = (
  userLocationCountry?: string,
): BillingDetailsFormData => {
  const saved = getSavedFormData(GIFTING_BILLING_DETAILS) as
    | BillingDetailsFormData
    | undefined;

  if (saved) return saved;

  const isoCountryCode =
    userLocationCountry && isSupportedCountry(userLocationCountry)
      ? userLocationCountry
      : "";
  const countryCallingCode = isoCountryCode
    ? getCountryCallingCode(isoCountryCode)
    : "";

  return {
    salutation: undefined,
    firstName: "",
    lastName: "",
    marketingConsent: false,
    phoneNumber: {
      countryCallingCode,
      isoCountryCode,
      nationalNumber: "",
    },
  };
};
